import * as React from 'react';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { COLOR } from '@src/styles/color';

const StyledTooltip = styled(({ className, ...props }) => (
  // eslint-disable-next-line react/jsx-filename-extension
  <Tooltip {...props} classes={{ popper: className }} />
))((props) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: COLOR.outlined[80],
    backdropFilter: 'blur(25px)',
    color: COLOR.white[100],
    borderRadius: '12px',
    fontSize: 14,
    fontWeight: 400,
    padding: '8px 16px',
    textAlign: 'center',
    maxWidth: props?.maxWidth,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: COLOR.outlined[80],
  },
}));

export { StyledTooltip };
